<template>
<div class="auth">
  <a-form
    id="components-form-demo-normal-login"
    :form="form"
    class="login-form"
    @submit="handleSubmit"
  >
    <a-form-item>
      <img height="120px" src="/logo-large-dark.png">
    </a-form-item>

    <a-form-item>
      <a-input
        v-decorator="[
          'username',
          { rules: [{ required: true, message: 'Please input your username!' }] },
        ]"
        placeholder="Username"
      >
        <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input
        v-decorator="[
          'password',
          { rules: [{ required: true, message: 'Please input your Password!' }] },
        ]"
        type="password"
        placeholder="Password"
      >
        <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
      </a-input>
    </a-form-item>
    <a-form-item>
      <!-- <a-checkbox
        v-decorator="[
          'remember',
          {
            valuePropName: 'checked',
            initialValue: true,
          },
        ]"
      >Remember me</a-checkbox> -->
      <!-- <a class="login-form-forgot" href>Forgot password</a> -->
      <a-button
        block
        type="primary"
        html-type="submit"
        class="login-form-button"
      >Log in</a-button>
    </a-form-item>
  </a-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  methods: {
    ...mapActions('auth',['loginUser']),
    async localLoginUser(values){
      try {
        await this.loginUser(values)
        this.$router.push('/')
      } catch (error) {
        console.error(error);
      }
      

    },
    handleSubmit(e) {
      e.preventDefault( );
      this.form.validateFields((err, values) => {
        if (!err) {
          this.localLoginUser(values)
        }
      });
    },
  },
};
</script>

<style scoped>
.auth {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
}
#components-form-demo-normal-login .login-form {
  max-width: 200px;
}
</style>